<app-breadcrumb [title]="'Alistamientos diarios'" [items]="['Vehiculos']"
  [active_item]="'Alistamientos diarios'"></app-breadcrumb>
<div class="container-fluid">
<div class="card">
  <div class="card-header d-flex align-items-center bg-primary text-white">
    <i class="icofont icofont-verification-check me-2"></i>
    <h5 class="mb-0"><strong>ALISTAMIENTOS DIARIOS</strong></h5>
  </div>

  <div class="card-body">
    <div class="col-sm-12 col-xl-12">
      <ul ngbNav #nav="ngbNav" class="nav-tabs" (navChange)="onTabChange($event)">
           <li [ngbNavItem]="1">
        
          <a ngbNavLink><strong>ESTADO ACTUAL</strong></a>
        
          <ng-template ngbNavContent>
            <form [formGroup]="formEstado">
              <div class="row mt-3">
                <div class="col-md-3">
                  <label class="form-label" for="fechaEstado"><strong>Fecha *:</strong></label>
                  <div class="input-group input-group-sm">
                    <input id="fechaEstado" type="date" class="form-control form-control-lg fs-14" name="fecha"
                      formControlName="fechaEstado" (change)="cargarEstadoActual()" [max]="hoy" onkeydown="return false;" />
                  </div>
                </div>
              </div>
            </form>
        
            <div class="row">
              <!-- Tabla a la izquierda -->
              <div class="col-md-6">
                <div class="custom-datatable table-responsive mt-4">
                  <table class="table table-hover table-bordered" id="tblListapreo">
              <thead class="bg-primary text-white">
                  <tr>
                    <th class="text-center text-uppercase" style="cursor: pointer" (click)="sortData('placa')">
                      <strong>Placa del Vehículo</strong>
                      <i class="fa ms-1" [ngClass]="{
                        'fa-sort-up': sortColumn === 'placa' && sortDirection === 'asc',
                        'fa-sort-down': sortColumn === 'placa' && sortDirection === 'desc',
                        'fa-sort': sortColumn !== 'placa'
                      }"></i>
                    </th>
                    <th class="text-center text-uppercase" style="cursor: pointer" (click)="sortData('estado_preoperacional')">
                      <strong>Estado</strong>
                      <i class="fa ms-1" [ngClass]="{
                        'fa-sort-up': sortColumn === 'estado_preoperacional' && sortDirection === 'asc',
                        'fa-sort-down': sortColumn === 'estado_preoperacional' && sortDirection === 'desc',
                        'fa-sort': sortColumn !== 'estado_preoperacional'
                      }"></i>
                    </th>
                    <th class="text-center text-uppercase"><strong>Acciones</strong></th>
                  </tr>
                </thead>
                    <tbody>
                     <tr *ngFor="let vehiculo of filteredTableItems | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
                        <td class="text-center text-uppercase">{{ vehiculo.placa }}</td>
                        <td class="text-center text-uppercase">
                          <span class="badge" [ngClass]="{
                                            'bg-success': vehiculo.estado_preoperacional === 'REALIZADO',
                                            'bg-danger': vehiculo.estado_preoperacional === 'NO REALIZADO'
                                          }">
                            {{ vehiculo.estado_preoperacional }}
                          </span>
                        </td>
                        <td class="text-center">
                          <li class="list-inline-item text-primary">
                            <a href="javascript:void(0)">
                              <i class="icon-file" *ngIf="vehiculo.estado_preoperacional === 'REALIZADO'"
                                (click)="GenerarFichaPreo(vehiculo.id)" placement="right" ngbTooltip="Generar Ficha"></i>
                            </a>
                          </li>
                  
                        </td>
                      </tr>
                    </tbody>
                  </table>
        </div>
        
        <!-- Controles de paginación y total -->
        <div class="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-2">
          <div class="d-flex align-items-center">
            <label for="pageSize1" class="me-2">Mostrar:</label>
            <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
              <option *ngFor="let size1 of [10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
            </select>
            <span class="ms-2">registros por página</span>
          </div>
        
          <div class="text-center">
            <span class="badge bg-primary">
              <b>Total Registros: {{ estadoPreoperacional.length || 0 }}</b>
            </span>
          </div>
        
          <div class="text-end">
            <pagination-controls (pageChange)="page1 = $event" [maxSize]="5" [directionLinks]="true" [autoHide]="true"
              previousLabel="Anterior" nextLabel="Siguiente">
            </pagination-controls>
          </div>
        </div>
        </div>
        
        <!-- Gráfico a la derecha -->
      <div class="col-md-6 d-flex justify-content-center align-items-center my-4">
        <apx-chart *ngIf="chartOptions" [series]="chartSeries" [chart]="chartOptions.chart" [labels]="chartOptions.labels"
          [colors]="chartOptions.colors" [legend]="chartOptions.legend" [responsive]="chartOptions.responsive"
          [title]="chartOptions.title">
        </apx-chart>
      </div>
        
        </div>
        
        </ng-template>
        </li>
        <li [ngbNavItem]="2">
          <a ngbNavLink><strong>CONSULTA DE ALISTAMIENTOS</strong></a>
          <ng-template ngbNavContent>
            <form [formGroup]="formPreoperacionales">
              <div class="row g-3 mb-3 my-4">
                <div class="col-md-3">
                  <label class="form-label" for="placa"><strong>Placa :</strong></label>
                  <ng-select formControlName="placa" id="vehiculos" [items]="vehiculos" bindLabel="placa"
                    bindValue="placa" placeholder="Selecciona una opción" class="js-example-placeholder-multiple">
                  </ng-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label"><strong>Conductor :</strong></label>
                  <ng-select formControlName="conductor" [items]="conductor" bindValue="cedula" [bindLabel]="'cedula'"
                    placeholder="Selecciona una opción" class="js-example-placeholder-multiple">
                    <ng-template ng-label-tmp let-item="item">
                      <span class="text-uppercase">
                        {{ item.cedula }} - {{ item.primernombre }} {{ item.segundonombre }} {{ item.papellidos }} {{
                        item.seapellidos }}
                      </span>
                    </ng-template>

                    <ng-template ng-option-tmp let-item="item">
                      <span class="text-uppercase">
                        {{ item.cedula }} - {{ item.primernombre }} {{ item.segundonombre }} {{ item.papellidos }} {{
                        item.seapellidos }}
                      </span>
                    </ng-template>
                  </ng-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="fecha"><strong>Fecha Inicial:</strong></label>
                  <div class="input-group input-group-sm">
                    <input id="fecha" formControlName="fecha" type="date" class="form-control form-control-lg fs-14"
                      name="fecha" (change)="actualizarMinFechaFinal()" [max]="hoy" onkeydown="return false;" />
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="fechaFinal"><strong>Fecha de Finalización:</strong></label>
                  <div class="input-group input-group-sm">
                    <input id="fechaFinal" formControlName="fechaFinal" type="date"
                      class="form-control form-control-lg fs-14" name="fechaFinal" [min]="minFechaFinal" [max]="hoy"
                      onkeydown="return false;" />
                  </div>
                </div>
              </div>
            </form>

            <!-- Borde alineado con formulario -->
            <div class="card card-absolute border border-primary rounded my-5">
              <div class="card-header bg-primary">
                <h5 class="text-white"><strong>FILTROS RÁPIDOS</strong></h5>
              </div>
              <div class="card-body">
                <div class="row g-3 mb-3">
                  <div class="col-md-2">
                    <button type="button" class="btn btn-outline-primary btn-sm w-100"
                      (click)="seleccionarRango('dia')"><strong>AYER</strong></button>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-outline-primary btn-sm w-100"
                      (click)="seleccionarRango('semana')"><strong>ÚLTIMA SEMANA</strong></button>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-outline-primary btn-sm w-100"
                      (click)="seleccionarRango('mes')"><strong>MES</strong></button>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-outline-primary btn-sm w-100"
                      (click)="seleccionarRango('trimestre')"><strong>TRIMESTRE</strong></button>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-outline-primary btn-sm w-100"
                      (click)="seleccionarRango('semestre')"><strong>SEMESTRE</strong></button>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-outline-primary btn-sm w-100"
                      (click)="seleccionarRango('anio')"><strong>AÑO</strong></button>
                  </div>

                </div>
              </div>
            </div>
            

            <div class="d-flex flex-column flex-md-row justify-content-center gap-2 gap-md-3 mt-3">

              <button class="btn btn-primary w-100 w-md-auto" type="button" placement="top" ngbTooltip="Consultar Alistamientos"
                (click)="buscarPreoperacionales()">
                <i class="icofont icofont-search"></i> Consultar</button>

              <button class="btn btn-info w-100 w-md-auto" type="button" placement="top" ngbTooltip="Generar Hoja"
                (click)="ExportarHoja()">
                <i class="icofont icofont-files"></i> Generar Hoja
              </button>

              <button class="btn btn-secondary w-100 w-md-auto" type="button" placement="top" ngbTooltip="Limpiar"
                (click)="limpiarFiltros()">
                <i class="icofont icofont-trash"></i> Limpiar
              </button>

               <button class="btn btn-success w-100 w-md-auto" type="button" placement="top" ngbTooltip="Exportar a Excel PESV"
                (click)="informepesv()">
                <i class="icofont icofont-file-excel"></i> Listado Alistamiento PESV
              </button>

               <button class="btn btn-success w-100 w-md-auto" type="button" placement="top" ngbTooltip="Exportar a Excel PESV"
                (click)="informeTrimestralPesv()">
                <i class="icofont icofont-file-excel"></i> Informe Trimestral PESV
              </button>
            </div>
          </ng-template>
        </li>
     
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>

</div>
</div>


<div class="card" *ngIf="mostrarTabla && tabActivo !== 1">


  <div class="card-body custom-datatable noscroll">
    <div class="row mb-12">
      <div class="col-3 ms-auto">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Buscar....." [(ngModel)]="searchText"
            (input)="filterData()" />
          <span class="input-group-text">
            <i class="fa fa-search"></i> <!-- Icono de búsqueda -->
          </span>
        </div>
      </div>
    </div>


    <div class="custom-datatable table-responsive my-4">
      <table class="table table-hover table-bordered" id="tblAlistamientoDiario">
        <thead class="bg-primary">
          <tr>
          <th class="text-center" (click)="sortData2('fecha')" style="cursor: pointer;">
        <strong>FECHA</strong>
        <i class="fa ms-1" [ngClass]="{
          'fa-sort-up': sortColumn === 'fecha' && sortDirection === 'asc',
          'fa-sort-down': sortColumn === 'fecha' && sortDirection === 'desc',
          'fa-sort': sortColumn !== 'fecha'
        }"></i>
      </th>
      <th class="text-center" style="cursor: pointer;">
       <strong>PLACA</strong>
       
      </th>
      <th class="text-center" (click)="sortData2('kilometraje')" style="cursor: pointer;">
        <strong>KM</strong>
        <i class="fa ms-1" [ngClass]="{
          'fa-sort-up': sortColumn === 'kilometraje' && sortDirection === 'asc',
          'fa-sort-down': sortColumn === 'kilometraje' && sortDirection === 'desc',
          'fa-sort': sortColumn !== 'kilometraje'
        }"></i>
      </th>
      <th class="text-center" (click)="sortData2('cedula')" style="cursor: pointer;">
        <strong>CÉDULA</strong>
        <i class="fa ms-1" [ngClass]="{
          'fa-sort-up': sortColumn === 'cedula' && sortDirection === 'asc',
          'fa-sort-down': sortColumn === 'cedula' && sortDirection === 'desc',
          'fa-sort': sortColumn !== 'cedula'
        }"></i>
      </th>
      <th class="text-center" (click)="sortData2('conductor')" style="cursor: pointer;">
       <strong>CONDUCTOR</strong>
        <i class="fa ms-1" [ngClass]="{
          'fa-sort-up': sortColumn === 'conductor' && sortDirection === 'asc',
          'fa-sort-down': sortColumn === 'conductor' && sortDirection === 'desc',
          'fa-sort': sortColumn !== 'conductor'
        }"></i>
      </th>
            <th class="text-center"><strong>ACCIONES</strong></th>


          </tr>
        </thead>

        <tbody>
          <tr
            *ngFor="let properacionales of filteredPreoperacionales | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
            <!-- <td class="text-center">{{ properacionales.id }}</td> -->
            <td class="text-center">{{ properacionales.fecha | date:'dd/MM/yyyy' }}</td>
            <td class="text-center">{{ properacionales.placa }}</td>
            <td class="text-center">{{ properacionales.kilometraje }}</td>
            <td class="text-center">{{ properacionales.cedula }}</td>
            <td class="text-center text-uppercase">
              {{ properacionales.conductor }}
              {{ properacionales.propietario?.segundoapellido }}
              {{ properacionales.propietario?.papellidos }}
              {{ properacionales.propietario?.seapellidos }}
            </td>
            <td>
              <div class="action text-center">
                <ul class="list-inline d-flex justify-content-center gap-3">
                  <li class="list-inline-item text-primary">
                    <a href="javascript:void(0)">
                      <i class="icon-file" (click)="GenerarFichaPreo(properacionales.id)" placement="right"
                        ngbTooltip="Generar Ficha"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </td>
          </tr>

          <tr *ngIf="filteredPreoperacionales && filteredPreoperacionales.length === 0">
            <td class="text-center text-warning" colspan="16">
              {{ mensajeBusqueda || 'No se encontraron resultados con los filtros proporcionados.' }}
            </td>
          </tr>
        </tbody>

      </table>


    </div>
    <div class="d-flex justify-content-between align-items-center mt-4">
      <!-- Selector de registros por página alineado a la izquierda -->
      <div class="d-flex align-items-center">
        <label for="pageSize1" class="me-2">Mostrar:</label>
        <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
          <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
        </select>
        <span class="ms-2">registros por página</span>
      </div>

      <div class="mx-auto text-center">
        <span class="badge bg-primary ms-1"><b><span>Total registros: </span>{{ filteredPreoperacionales?.length || 0
            }}</b></span>

      </div>

      <!-- Paginador alineado a la derecha -->
      <div class="text-end paginador-personalizado">
        <pagination-controls (pageChange)="page1 = $event" [maxSize]="5" [directionLinks]="true" [autoHide]="true"
          previousLabel="Anterior" nextLabel="Siguiente">
        </pagination-controls>
      </div>
    </div>
    <div class="card-body">
      <div class="btn-showcase text-center">
        <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
          (click)="exportarExcel('tblAlistamientoDiario', 'Listado_Alistamiento_Diario')">
          <i class="icofont icofont-file-excel"></i> EXCEL
        </button>

        <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF" (click)="
            exportToPDF(
              'tblAlistamientoDiario',
              'Listado_Alistamiento_Diario',
              'Listado de Alistamiento Diario'
            )
          ">
          <i class="icofont icofont-file-pdf"></i> PDF
        </button>

      </div>
    </div>
  </div>

</div>


<div class="toast-container position-fixed bottom-0 end-0 p-3" style="z-index: 1055" aria-live="polite"
  aria-atomic="true">
  <div *ngIf="mostrandoToast" class="toast show align-items-center text-white bg-primary border-0" role="alert"
    aria-live="assertive" aria-atomic="true">
    <div class="d-flex">
      <div class="toast-body">
        <div class="spinner-border spinner-border-sm me-2" role="status"></div>
        Generando Documento...
      </div>
    </div>
  </div>
</div>